import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PI } from '../../constants-types';
import {
    upgradeButtonLocation,
    upgradeStatus
} from '../../constants-types/constants';
import { SiteNavigationService } from '../../core-services';
import { InitDataService, Logger } from '../../system-services';
import { PardotService } from './Pardot.service';
import { SalesChatBotService } from './SalesChatBot.service';
declare let pendo: any;

@Injectable({ providedIn: 'root' })
export class UpgradeAccountService {
    upgradeButtonDisabled = false;
    isDirectClient: boolean;

    private $upgradeAccountButton: BehaviorSubject<{
        clicked: boolean;
        location: upgradeButtonLocation;
    }> = new BehaviorSubject<{
        clicked: boolean;
        location: upgradeButtonLocation;
    }>({
        clicked: false,
        location: ''
    });
    private $accountUpgradeStatus: BehaviorSubject<upgradeStatus> =
        new BehaviorSubject<upgradeStatus>(null);

    constructor(
        private init: InitDataService,
        private pardot: PardotService,
        private logger: Logger,
        private siteNavigation: SiteNavigationService,
        private readonly salesChatBot: SalesChatBotService
    ) {}

    get accountUpgradeStatusObservable(): Observable<upgradeStatus> {
        return this.$accountUpgradeStatus;
    }

    get upgradeAccountButtonObservable(): Observable<{
        clicked: boolean;
        location: upgradeButtonLocation;
    }> {
        return this.$upgradeAccountButton;
    }

    setUpgradeAccountButton(
        isClicked: boolean,
        location: upgradeButtonLocation
    ): void {
        this.$upgradeAccountButton.next({
            clicked: isClicked,
            location: location
        });
    }

    setAccountUpgradeStatus(status: upgradeStatus): void {
        this.$accountUpgradeStatus.next(status);
    }

    async setIsDirect() {
        await this.init.getPartnerData();
        this.isDirectClient = this.init.account?.isDirectClient;
    }

    async upgradeAccount(requestFromPaywall: boolean): Promise<void> {
        await this.setIsDirect();
        // Log that the click was made and by who
        this.logger.logInfo(
            `Upgrade button clicked in global navigation by ${
                this.isDirectClient ? 'Direct Client' : 'Partner Client'
            } for ${this.siteNavigation.currentModule}`,
            {
                userId: this.init.user.userId,
                email: this.init.user.email,
                companyId: this.init.user.companyId
            }
        );
        if (this.isDirectClient) {
            this.openSalesChatBot();
        } else {
            this.showPendoPopup();
        }
        this.setUpgradeAccountButton(
            true,
            requestFromPaywall ? 'paywall' : 'header'
        );
    }

    private openSalesChatBot(): void {
        this.salesChatBot.triggerChatBot();
    }

    private async showPendoPopup(): Promise<void> {
        // Open pendo popup letting them know we alerted the partner
        if (PI.appSettings.pendoOn) {
            pendo.showGuideById(PI.appSettings.pricingPackagingPendoPopupId);
        }
        await this.pardot.sendPricingPackagingPartnerRequest(
            this.siteNavigation.currentModule + ' Pricing and Packaging Button'
        );
    }
}
